// extracted by mini-css-extract-plugin
export default {"loading":"Login_loading__vVBqW","wrapper":"Login_wrapper__OYBuw","form":"Login_form__B6Xbv","goBack":"Login_goBack__26eiI"};